module.exports = __webpack_public_path__ + "static/media/tetris.5541350c.png";